import React, { useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { usePatchForm } from '../../providers/PatchFormProvider';

const RegistryKeyChange = () => {
  const { patchFormData, setPatchFormData } = usePatchForm();

  const [isExpanded, setIsExpanded] = useState(false);
  const [registryType, setRegistryType] = useState('');
  const [apply, setApply] = useState(false);

  const [registryData, setRegistryData] = useState({
    ActionType: 'RegistryUpdate',
    WhenToExecute: 'PostRemediation',
    OperationType: 'Update',
    RegistryKeyPath: '',
    RegistryKeyName: '',
    RegistryKeyValue: '',
  });

  const applyRegistry = () => {
    setApply(true);
    setPatchFormData((prev) => {
      const updatedList = (prev.RemediationPlanActionList ?? []).filter((a) => a.ActionType !== 'RegistryUpdate');
      return {
        ...prev,
        RemediationPlanActionList: [...updatedList, registryData],
      };
    });
    setIsExpanded(false);
  };

  useEffect(() => {
    if (patchFormData?.RemediationPlanActionList) {
      const savedRegistry = patchFormData.RemediationPlanActionList.find((action) => action.ActionType === 'RegistryUpdate');
      if (savedRegistry) {
        setRegistryData(savedRegistry);
        setApply(true);
      }
    }
  }, [patchFormData]);

  return (
    <div className={`bg-[#1e1e1e] text-white p-4 rounded-md border ${apply ? 'border-green-500' : 'border-gray-600'}`}>
      <div
        className="flex justify-between items-center cursor-pointer p-3 bg-[#2a2a2a] rounded-md"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span>Change Registry Key</span>
        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
      </div>

      {isExpanded && (
        <div className="mt-2 bg-[#2a2a2a] border border-gray-600 rounded-md p-4">
          <div className="mb-3">
            <label className="block text-sm font-bold mb-2">Key Path ending with key name</label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-[#1e1e1e] text-white"
              type="text"
              placeholder="Enter key path"
              value={registryData.RegistryKeyPath}
              onChange={(e) =>
                setRegistryData((prev) => ({
                  ...prev,
                  RegistryKeyPath: e.target.value,
                }))
              }
            />
          </div>

          {/* <div className="mb-3">
            <label className="block text-sm font-bold mb-2">Registry Type</label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-[#1e1e1e] text-white"
              type="text"
              placeholder="Enter registry type"
              value={registryType}
              onChange={(e) => setRegistryType(e.target.value)}
            />
          </div> */}

          <div className="mb-3">
            <label className="block text-sm font-bold mb-2">Registry Value Name</label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-[#1e1e1e] text-white"
              type="text"
              placeholder="Enter value name"
              value={registryData.RegistryKeyName}
              onChange={(e) =>
                setRegistryData((prev) => ({
                  ...prev,
                  RegistryKeyName: e.target.value,
                }))
              }
            />
          </div>

          <div className="mb-3">
            <label className="block text-sm font-bold mb-2">Registry Value Data</label>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-[#1e1e1e] text-white"
              type="text"
              placeholder="Enter value data"
              value={registryData.RegistryKeyValue}
              onChange={(e) =>
                setRegistryData((prev) => ({
                  ...prev,
                  RegistryKeyValue: e.target.value,
                }))
              }
            />
          </div>

          <div className="mb-3">
            <label className="block text-sm font-bold mb-2">Add new name</label>
            <div className="shadow appearance-none border border-gray-600 rounded w-full py-2 px-3 bg-[#1e1e1e]">
              <div className="flex flex-col space-y-4">
                <label className="inline-flex items-center ">
                  <input
                    type="radio"
                    className="form-radio h-5 w-5 text-gray-600 bg-[#1e1e1e] accent-green-500"
                    name="addNewName"
                    checked={registryData.OperationType === 'Insert'}
                    onChange={(e) =>
                      setRegistryData((prev) => ({
                        ...prev,
                        OperationType: 'Insert',
                      }))
                    }
                  />
                  <span className="ml-2 text-gray-300">Insert</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    className="form-radio h-5 w-5 text-gray-600  bg-[#1e1e1e] accent-green-500"
                    name="addNewName"
                    checked={registryData.OperationType === 'Update'}
                    onChange={(e) =>
                      setRegistryData((prev) => ({
                        ...prev,
                        OperationType: 'Update',
                      }))
                    }
                  />
                  <span className="ml-2 text-gray-300">Update</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    className="form-radio h-5 w-5 text-gray-600  bg-[#1e1e1e] accent-green-500"
                    name="addNewName"
                    checked={registryData.OperationType === 'Delete'}
                    onChange={(e) =>
                      setRegistryData((prev) => ({
                        ...prev,
                        OperationType: 'Delete',
                      }))
                    }
                  />
                  <span className="ml-2 text-gray-300">Delete</span>
                </label>
              </div>
            </div>
          </div>

          <div className="mt-3 flex justify-start gap-3">
            <button
              className="px-4 py-2 border border-gray-400 rounded-[30px]"
              onClick={() => {
                setApply(false);
                setIsExpanded(false);
              }}
            >
              Cancel
            </button>
            <button className="px-4 py-2 bg-red-600 rounded-[30px]" onClick={() => applyRegistry()}>
              Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistryKeyChange;
